module.exports = require("lodash/size");


//////////////////
// WEBPACK FOOTER
// external "lodash/size"
// module id = 60
// module chunks = 0